import React, { useState } from 'react'
import { orderTypes } from 'utils/appUtils'

// Internal imports
import CreateAccount from 'components/register/CreateAccount'
import EnterAddress from './EnterAddress'
import constants from 'utils/constants'

export default function (props) {
    const selectedAddress = props.deliveryAddress
    const [formState, setFormState] = useState(
        selectedAddress.type === orderTypes.DELIVERY && selectedAddress.formatted_address ? 2 : 1
    )
    const nextForm = () => {
        setFormState(formState => formState + 1)
    }

    const prevForm = () => {
        setFormState(formState => formState - 1)
    }

    switch (formState) {
        case constants.enterDeliveryAddressStep:
        case constants.confirmDeliveryAddressStep: {
            return (
                <EnterAddress
                    {...props}
                    nextForm={nextForm}
                    prevForm={prevForm}
                    formState={formState}
                >
                    {props.children}
                </EnterAddress>
            )
        }
        case constants.createAccountStep: {
            return (
                <CreateAccount
                    {...props}
                    nextForm={nextForm}
                    prevForm={prevForm}
                    hide={props.hide}
                ></CreateAccount>
            )
        }
        default:
            return (
                <EnterAddress
                    {...props}
                    nextForm={nextForm}
                    prevForm={prevForm}
                    formState={formState}
                >
                    {props.children}
                </EnterAddress>
            )
    }
}
